import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../exo/ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewSalesObject = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Title Image'),
      type: 'image',
      key: 'image',
    },
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      label: `${t('Prefix')} (${t('optional')})`,
      type: 'text',
      key: 'prefix',
    },
    {
      label: t('Object supervisor'),
      type: 'user',
      key: 'supervisor',
    },
    {
      label: t('Owner'),
      type: 'client',
      key: 'owner',
    },
  ];

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t('Is required')),
    supervisor: Yup.object().shape({
      id: Yup.string().required(t('Is required')),
    }),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate ? `sales-objects/${data.id}` : `sales-objects`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  return (
    <ExoForm
      header={
        startData?.id ? t('Update Sales Object') : t('Create Sales Object')
      }
      fields={fields}
      startDataCollection={startData || { status: 0, ownerType: 'internal' }}
      onSubmit={handleSubmit}
      onCancle={onClose}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
    />
  );
};
